import { render, staticRenderFns } from "./UsedDyestuffs.vue?vue&type=template&id=48ef2f55"
import script from "./UsedDyestuffs.vue?vue&type=script&lang=ts"
export * from "./UsedDyestuffs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports